import viewsi18n from './views';
import componentsi18n from './components';
import libsi18n from './libs';

export default {
  ...viewsi18n,
  ...componentsi18n,
  ...libsi18n
};



// WEBPACK FOOTER //
// ./src/i18n/de/index.js